import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import ReferralOptions from '../ReferralsIndexContainer/ReferralOptions';
function EmployerReferralModal(_ref) {
  var showModal = _ref.showModal,
    onHideCallback = _ref.onHideCallback,
    csrfToken = _ref.csrfToken,
    referralPath = _ref.referralPath,
    newReferralPath = _ref.newReferralPath,
    shareOnLinkedinUrl = _ref.shareOnLinkedinUrl,
    authCodeUrl = _ref.authCodeUrl,
    authStatus = _ref.authStatus,
    referralHeroCopy = _ref.referralHeroCopy;
  return /*#__PURE__*/React.createElement(Modal, {
    show: showModal,
    onHide: onHideCallback
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(ReferralOptions, {
    csrfToken: csrfToken,
    referralPath: referralPath,
    newReferralPath: newReferralPath,
    shareOnLinkedinUrl: shareOnLinkedinUrl,
    authCodeUrl: authCodeUrl,
    authStatus: authStatus,
    referredUserType: "employer",
    heroCopy: referralHeroCopy,
    location: "Employer Post-Hire",
    isConsultant: false,
    showSocialMediaShareButtons: true
  })));
}
EmployerReferralModal.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  referralPath: PropTypes.string.isRequired,
  newReferralPath: PropTypes.string.isRequired,
  shareOnLinkedinUrl: PropTypes.string.isRequired,
  referralHeroCopy: PropTypes.string.isRequired,
  authCodeUrl: PropTypes.string,
  authStatus: PropTypes.number,
  showModal: PropTypes.bool.isRequired,
  onHideCallback: PropTypes.func.isRequired
};
EmployerReferralModal.defaultProps = {
  authCodeUrl: null,
  authStatus: null
};
export default EmployerReferralModal;